import React from 'react';
import PropTypes from 'prop-types';
import Popup from './Popup';
import CloseButton from '../buttons/CloseButton';

const DismissiblePopup = ({ header, message, buttons, onClose, cssClass }) => {
    const headerContent = (
        <div className='dashboard-popup-header-content'>
            <p>
                <span className='dashboard-light'>{header}</span>
            </p>
            <CloseButton onClick={onClose} />
        </div>
    );

    return <Popup header={headerContent} message={message} buttons={buttons} cssClass={cssClass} />;
};

DismissiblePopup.propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttons: PropTypes.arrayOf(PropTypes.element),
    onClose: PropTypes.func.isRequired,
    cssClass: PropTypes.string,
};

DismissiblePopup.defaultProps = {
    header: '',
    message: '',
    buttons: [],
    cssClass: '',
};

export default DismissiblePopup;
